/*!
 * Glance Digital Custom JavaScript Programing
 * lance@glance.ca
 *
 */

jQuery(document).ready(function ($) {
  // SETTINGS
  // ------------------

  // Velocty Easing
  // ------

  $.Velocity.defaults.easing = "easeInOutQuart";

  // Init Page Scripts
  // ------

  // Top Header Nav
  if ($(".site-header").length) {
    $(".site-header").topNav();
  }

  // Form Labels
  if ($(".gform_wrapper").length) {
    $(".gform_wrapper").formLabels();
  }
  $("#barba-container").initPage();
  if ($("#barba-wrapper").length) {
    $("#barba-wrapper").pageTransitions();
  }
});

// ------------------------------------------------------------------------------------------------------------------------------------------------
// PLUGINS

(function ($) {
  // Init Page Scripts
  // ------

  $.fn.initPage = function () {
    // Reset page after pajax transition
    $("html").velocity("scroll", {
      duration: 0,
      offset: 0
    });
    if ($(".site-header").length) {
      $(".site-header").resetTopNav();
    }
    if ($(".presentation-template").length) {
      $(".site-header").hide();
    } else {
      $(".site-header").show();
    }
    if ($(".contact-container").length) {
      $(".site-footer").hide();
    } else {
      $(".site-footer").show();
    }
    if ($(".form-template").length) {
      $(".site-footer").addClass("no-newsletter");
    } else {
      $(".site-footer").removeClass("no-newsletter");
    }

    // Anchor Link Scroll
    $("a[href^='#']").scrollto({
      offset_lg: 80,
      offset_sm: 68
    });

    // Forms
    if ($(".gf_ajax_form_container").length) {
      $(".gf_ajax_form_container").ajaxGravityForms();
    }

    // Before / After
    if ($(".before-after").length) {
      $(".before-after").each(function () {
        $(this).beforeAfter();
      });
    }

    // Background Video
    if ($(".video-container").length) {
      $(".video-container").each(function () {
        $(this).bgVideo();
      });
    }

    // Post Filters Dropdown
    $("#filter").postFiltersDropdown();

    // Gallery Slider
    if ($(".module-gallery .swiper-slide").length > 1) {
      $(".module-gallery").each(function () {
        $(this).gallery({});
      });
    }

    // Hotspots
    if ($(".module-hotspots li").length) {
      $(".module-hotspots").each(function () {
        $(this).hotspots({});
      });
    }

    // Ajax load more
    if ($(".project-list #postslist").length) {
      $(".project-list #postslist").ajaxLoad({
        base: "/projects/",
        post_type: "c_project",
        template: "parts/loop-project.php",
        orderby: "menu_order"
      });
    }
    if ($(".person-list #postslist").length) {
      $(".person-list #postslist").ajaxLoad({
        post_type: "c_person",
        template: "parts/loop-person.php",
        orderby: "menu_order",
        auto_load: true
      });
    }
    if ($(".news-list #postslist").length) {
      $(".news-list #postslist").ajaxLoad({
        base: "/news/",
        filter_type: "single",
        post_type: "post",
        template: "parts/loop-archive.php",
        filter: "#filter .category"
      });
    }
    if ($(".ideas-list #postslist").length) {
      $(".ideas-list #postslist").ajaxLoad({
        base: "/ideas/",
        filter_type: "single",
        post_type: "c_idea",
        template: "parts/loop-idea.php",
        filter: "#filter .category"
      });
    }

    // Toggle list/grid view
    if ($(".grid-list-view-toggle").length) {
      $(".grid-list-view-toggle").gridListToggle();
    }

    // Expanding Content module
    if ($(".expand .more").length) {
      $(".expand .more").expandingContent();
    }

    // Banner Image Parallax (parallax.js)
    if ($(".parallax").length) {
      $(".parallax").parallax({
        offsetIntertia: -0.15
      });
    }

    // Show in View (inview-animate.js)

    if ($(".showOnView.slideUp").length) {
      $(".showOnView.slideUp").showOnView({
        transitionIn: "transition.slideUpIn"
      });
    }
    if ($(".showOnView.slideUpBig").length) {
      $(".showOnView.slideUpBig").showOnView({
        transitionIn: "transition.slideUpBigIn"
      });
    }
    if ($(".showOnView.slideLeft").length) {
      $(".showOnView.slideLeft").showOnView({
        transitionIn: "transition.slideLeftBigIn"
      });
    }
    if ($(".showOnView.slideRight").length) {
      $(".showOnView.slideRight").showOnView({
        transitionIn: "transition.slideRightBigIn"
      });
    }
    if ($(".showOnView.slideIn").length) {
      $(".showOnView.slideIn").showOnView({
        transitionIn: "transition.fadeIn"
      });
    }
    if ($(".showOnView.shareThis").length) {
      $(".showOnView.shareThis").showOnView({
        transitionDelay: 900,
        transitionIn: 'transition.slideRightBigIn',
        transitionSpeed: 300
      });
    }

    // Init Breakpoint Listeners
    // ------------------

    $(this).breakpoints();
  };

  // Page Transitions
  // ------

  $.fn.pageTransitions = function () {
    Barba.Pjax.start();
    $("#barba-container").removeClass("loading");
    var customTransitions = Barba.BaseTransition.extend({
      start: function start() {
        // As soon the loading is finished and the old page is faded out, let's fade the new page
        Promise.all([this.newContainerLoading, this.takeOut()]).then(this.bringIn.bind(this));
      },
      takeOut: function takeOut() {
        // this.oldContainer is the HTMLElement of the old Container
        $(this.oldContainer).addClass("unloading").promise();
      },
      bringIn: function bringIn() {
        /**
         * this.newContainer is the HTMLElement of the new Container
         * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
         * Please note, newContainer is available just after newContainerLoading is resolved!
         */

        var _this = this;
        var $el = $(this.newContainer);
        var $old = $(this.oldContainer);
        $old.addClass("old").delay(425).hide(0, function () {
          // .done() will automatically remove from the DOM the old Container
          _this.done();

          // show new page
          $el.removeClass("loading");
          $el.initPage();
        });
        $el.addClass("loading").css({
          visibility: "visible"
        });
      }
    });

    //Next step, you have to tell Barba to use the new Transition
    Barba.Pjax.getTransition = function () {
      return customTransitions;
    };
  };

  // Top Nav
  // ------

  $.fn.topNav = function (options) {
    var settings = $.extend({
      trigger_offset: 100
    }, options);
    var $window = $(window);
    var $body = $("body");
    var $header = $(".site-header");
    var $topNavDropdown = this.find(".hamburger");
    var scrollTop = $window.scrollTop();
    var min = false;
    var mouseout = false;
    $topNavDropdown.on("click", function (e) {
      e.preventDefault();
      if ($body.hasClass("header-open")) {
        $topNavDropdown.removeClass("is-active");
        $body.removeClass("header-open");
      } else {
        $topNavDropdown.addClass("is-active");
        $body.addClass("header-open");
      }
    });
    $header.on("mouseover", function () {
      mouseout = false;
    }).on("mouseout", function () {
      mouseout = true;
      setTimeout(function () {
        if (mouseout && $body.hasClass("header-open")) {
          $topNavDropdown.removeClass("is-active");
          $body.removeClass("header-open");
        }
      }, 1000);
    });
    function scrollState() {
      scrollTop = $window.scrollTop();

      // Minimized Top State
      if (scrollTop >= settings.trigger_offset && !min) {
        min = true;
        $body.addClass("header-minimize");

        // Full Top State
      } else if (scrollTop < settings.trigger_offset && min) {
        min = false;
        $body.removeClass("header-minimize");
      }
    }
    $window.on("scroll.menustate", scrollState);
    scrollState();
  };
  $.fn.resetTopNav = function () {
    var $body = $("body");
    var $topNavDropdown = this.find(".hamburger");
    $topNavDropdown.removeClass("is-active");
    $body.removeClass("header-open");
  };

  // Ajax Gravity Forms
  // ------

  $.fn.ajaxGravityForms = function () {
    $container = this;
    form_id = this.data("form_id");
    $.get(glance.ajaxUrl + "?action=gf_ajax_get_form&form_id=" + form_id, function (response) {
      $container.html(response).fadeIn();
      // if (window["gformInitDatepicker"]) {
      //   gformInitDatepicker();
      // }
    });

    $(document).bind("gform_post_render", function () {
      var gfRecaptchaPoller = setInterval(function () {
        if (!window.grecaptcha || !window.grecaptcha.render) {
          return;
        }
        renderRecaptcha();
        clearInterval(gfRecaptchaPoller);
      }, 100);
    });
  };

  // Form Labels
  // ------

  $.fn.formLabels = function () {
    var $container = this;
    function status() {
      $container.find("input, textarea").each(function () {
        if ($(this).val() != "") {
          $(this).closest(".gfield").addClass("focus");
        }
      });
    }
    $container.on("focus", "input, textarea", function () {
      $(this).closest(".gfield").addClass("focus");
    }).on("blur", "input, textarea", function () {
      if ($(this).val() == "") {
        $(this).closest(".gfield").removeClass("focus");
      }
    });
    $(document).on("gform_post_render", function (event, formId) {
      $container = $("#gform_wrapper_" + formId);
      status();
    });
    return this;
  };

  // Anchor scroll
  // ------

  $.fn.scrollto = function (options) {
    var settings = $.extend({
      offset_lg: 0,
      offset_sm: 0,
      exclude: "more"
    }, options);
    var offset = settings.offset_lg;
    $.subscribe("breakpoints", function (obj, media) {
      offset = media.small ? settings.offset_sm : settings.offset_lg;
    });
    this.on("click", function (event) {
      var id = $(this).attr("href").split("#")[1];
      if ($("#" + id).length && !$(this).hasClass(settings.exclude)) {
        event.preventDefault();
        var $el = $("#" + id);
        var top = id == "top" ? $el.offset().top : $el.offset().top - offset;
        $("html").velocity("scroll", {
          duration: 900,
          offset: top
        });
      }
    });
    return this;
  };

  // Before / After slider
  // ------

  $.fn.beforeAfter = function () {
    var $window = $(window);
    var $container = this;
    var $before = this.find(".before");
    var $before_img = $before.find(".img");
    $container.on("touchmove", function (e) {
      var x = e.changedTouches[0].pageX - $container.offset().left;
      dragMove(x);
    });
    $container.on("mousemove", function (e) {
      var x = e.pageX - $container.offset().left;
      dragMove(x);
    });
    function dragMove(x) {
      var w = $container.outerWidth();
      var perc = x / w * 100;
      $before.css("width", perc + "%");
      sizeImg();
    }
    function sizeImg() {
      $before_img.css("width", $container.outerWidth());
    }
    $window.on("resize", function () {
      sizeImg();
    });
    sizeImg();
  };
  $.fn.bgVideo = function () {
    var $container = this;
    var $video = this.find("iframe");
    $container.on("click", function () {
      var videoURL = $video.prop("src");
      if ($container.hasClass("playing")) {
        videoURL = videoURL.replace("mute=0", "mute=1");
        videoURL = videoURL.replace("controls=1", "controls=0");
      } else {
        videoURL = videoURL.replace("mute=1", "mute=0");
        videoURL = videoURL.replace("controls=0", "controls=1");
      }
      $video.prop("src", "");
      $video.prop("src", videoURL);
      $container.toggleClass("playing");
    });
  };

  // Post Filters Dropdown Panel
  // ------

  $.fn.postFiltersDropdown = function (options) {
    var settings = $.extend({
      top: ".filter-top-panel",
      bottom: ".filter-dropdown-panel",
      list: ".filter-list",
      toggle: ".filter-top-panel .selection, .filter-dropdown-panel-actions button",
      actions: ".filter-dropdown-panel-actions"
    }, options);
    var $this = this;
    var expanded = this.attr("aria-expanded");
    var $top = this.find(settings.top);
    var $btm = this.find(settings.bottom);
    var $list = this.find(settings.list);
    var $toggle = this.find(settings.toggle);
    var $actions = this.find(settings.actions);
    $toggle.on("click", function () {
      if (expanded) {
        $btm.velocity("slideUp");
        $this.attr("aria-expanded", "false");
        expanded = false;
      } else {
        $btm.velocity("slideDown", {
          complete: function complete() {
            // $list.scrollTop(0);
            $list.animate({
              scrollTop: 0
            }, 250);
          }
        });
        $this.attr("aria-expanded", "true");
        expanded = true;
      }
      $("html").velocity("scroll", {
        duration: 450,
        offset: $this.offset().top
      });
    });
    function listSize() {
      var h = $(window).height() - $top.outerHeight();
      $list.css("max-height", h);
    }
    $(window).on("resize", function () {
      listSize();
    });
    $.subscribe("filter_dropdown_apply", function (obj) {
      listSize();
    });
    listSize();
  };

  // Gallery Slider

  $.fn.gallery = function (options) {
    var settings = $.extend({
      initialize: false
    }, options);
    var $this = this;
    var $captionTarget = $this.find(".gallery--captions");
    var gallery = null;
    var id = this.find(".swiper-container").length ? this.find(".swiper-container").attr("id") : null;
    if (id) {
      gallery = new Swiper("#" + id, {
        observer: settings.initialize,
        observeParents: settings.initialize,
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 4,
        navigation: {
          nextEl: ".pagination .swiper-button-next",
          prevEl: ".pagination .swiper-button-prev"
        }
      });
      gallery.on("transitionEnd", function () {
        publishSlideChange($this);
      });
      setTimeout(function () {
        publishSlideChange($this);
      }, 300);
    }
    function publishSlideChange(gallery) {
      var $caption = gallery.find('.swiper-slide-active figcaption').children();
      $captionTarget.empty().append($caption.clone());
    }
    return gallery;
  };

  // Hotspots
  $.fn.hotspots = function (options) {
    var settings = $.extend({}, options);
    var $this = this;
    var $image = $this.find(".hotspots--image li");
    var $captions = $this.find(".hotspots--captions li");
    function setIsActive(index) {
      $image.removeClass("is-active").eq(index).addClass("is-active");
      $captions.removeClass("is-active").eq(index).addClass("is-active");
    }
    function clearActive() {
      $image.removeClass("is-active");
      $captions.removeClass("is-active");
    }
    $image.on("mouseover", function () {
      setIsActive($(this).index());
    }).on("mouseout", function () {
      clearActive();
    });
    $captions.on("mouseover", function () {
      setIsActive($(this).index());
    }).on("mouseout", function () {
      clearActive();
    });
    return this;
  };

  // Ajax filter/paginate posts list
  // ------

  $.fn.ajaxLoad = function (options) {
    var settings = $.extend({
      base: false,
      filter_type: "multi",
      post_type: "c_project",
      page_action: "posts_load",
      paginate: "#paginateNav a",
      post: ".ajax-post",
      posts_per_page: "posts_per_page",
      filter: "#filter .filter-dropdown-panel .category",
      apply: "#filter .filter-dropdown-panel-actions button.apply",
      cancel: "#filter .filter-dropdown-panel-actions button.icon-clear",
      mobile_select_filter: "#filter .filter-top-panel .category",
      clear_filters: "#filter .filter-top-panel .clear-filters",
      selection_label: "#filter .filter-top-panel .selection",
      template: "parts/loop-project.php",
      orderby: "date",
      auto_load: false
    }, options);
    var $container = this;
    var container_classes = $container.attr("class");
    var $paginateNav = $(settings.paginate);
    var pageIsLoading = false;
    var postsPerPage = this.data(settings.posts_per_page);
    var $filters = $(settings.filter);
    var $mobile_select_filters = $(settings.mobile_select_filter);
    var $clear_filters = $(settings.clear_filters);
    var $apply = $(settings.apply);
    var $cancel = $(settings.cancel);
    var filter = [];
    var filter_str = "";
    updateFilter();
    $paginateNav.on("click", function (e) {
      e.preventDefault();
      updateFilter();
      ajaxLoad("paginate");
    });
    if (settings.auto_load) {
      $paginateNav.on("inview", function (event, visible, topOrBottomOrBoth) {
        if (visible == true) {
          updateFilter();
          ajaxLoad("paginate");
        }
      });
    }
    $filters.find("li").on("click", function () {
      var $li = $(this);
      if (settings.filter_type == "multi") {
        if ($li.data("filter") == "all") {
          $li.addClass("selected").siblings().removeClass("selected");
        } else {
          $li.toggleClass("selected");
          $li.parent().find("li[data-filter='all']").removeClass("selected");
        }
      } else {
        $li.addClass("selected").siblings().removeClass("selected");
        updateFilter();
        ajaxLoad("filter");
      }
    });
    $apply.on("click", function () {
      updateFilter();
      ajaxLoad("filter");
    });
    $cancel.on("click", function () {
      restoreFilters();
    });
    $clear_filters.on("click", function () {
      $filters.find("li").removeClass("selected").filter("[data-filter='all']").addClass("selected");
      updateFilter();
      ajaxLoad("filter");
    });
    $mobile_select_filters.find("select").on("change", function () {
      var tax = $(this).data("taxonomy");
      $(settings.filter + "[data-taxonomy='" + tax + "']").find("li[data-filter='" + this.value + "']").trigger("click");
      updateFilter();
      ajaxLoad("filter");
    });
    function updateBrowserState(filter) {
      if (settings.base) {
        window.history.replaceState("filter", "Filter", settings.base + filter);
      }
    }
    function restoreFilters() {
      if (filter.length) {
        $.each(filter, function (i, val) {
          var terms = val.terms;
          var $taxlist = $(settings.filter + "[data-taxonomy='" + val.taxonomy + "']");
          $taxlist.find("li").removeClass("selected").each(function () {
            var $this = $(this);
            var li_term = $this.data("filter");
            $.each(terms, function (j, term) {
              if (li_term == term) {
                $this.addClass("selected");
              }
            });
          });
          if (!$taxlist.find("li.selected").length) {
            $taxlist.find("li[data-filter='all']").addClass("selected");
          }
        });
      } else {
        $filters.find("li").removeClass("selected").filter("[data-filter='all']").addClass("selected");
      }
    }
    function updateFilter() {
      filter = [];
      var pos = 0;
      var list_is_filtered = false;
      $filters.each(function () {
        var $this = $(this);
        var taxonomy = $this.data("taxonomy");
        filter.push({
          taxonomy: taxonomy,
          terms: []
        });
        $(settings.selection_label + "." + taxonomy).text("");
        if ($this.find("li.selected").length == $this.find("li:not([data-filter='all'])").length) {
          $this.find("li").removeClass("selected");
          $this.find("li[data-filter='all']").addClass("selected");
        }
        $this.find("li").each(function () {
          var $li = $(this);
          if ($li.hasClass("selected") && $li.data("filter") != "all") {
            list_is_filtered = true;
            filter[pos].terms.push($li.data("filter"));
            var existing = $(settings.selection_label + "." + taxonomy).text();
            var prefix = existing == "" ? "" : ", ";
            $(settings.selection_label + "." + taxonomy).text(existing + prefix + $li.text());
          }
        });
        if ($(settings.selection_label + "." + taxonomy).text() == "") {
          $(settings.selection_label + "." + taxonomy).text("All");
        }
        pos++;
      });
      filter_str = filter.length ? JSON.stringify(filter) : "";
      if (list_is_filtered) {
        $clear_filters.show(0);
      } else {
        $clear_filters.hide(0);
      }
      $.publish("filter_dropdown_apply", [{}]);
      $container.attr("class", container_classes);
      if (list_is_filtered && settings.filter_type == "single") {
        updateBrowserState(filter[0].terms[0] + "/");
      } else if (list_is_filtered && settings.filter_type == "multi") {
        var states = new Array();
        var service_term_classes = "";
        $.each(filter, function (i, obj) {
          if (obj.terms && obj.terms.length) {
            var pretty_taxonomy = obj.taxonomy;
            if (pretty_taxonomy == "c_project_service") {
              pretty_taxonomy = "service";
              service_term_classes = obj.terms.join(" ");
              $container.addClass(service_term_classes);
            } else if (pretty_taxonomy == "c_project_type") {
              pretty_taxonomy = "type";
            }
            states.push(pretty_taxonomy + "=" + obj.terms.join(","));
          }
        });
        updateBrowserState("?" + states.join("&"));
      } else {
        updateBrowserState("");
      }
    }
    function ajaxLoad(action) {
      if (!pageIsLoading) {
        pageIsLoading = true;
        $container.addClass("loading " + action);
        $paginateNav.addClass("loading " + action);
        var offset = action == "paginate" ? $container.find(settings.post).length : 0;
        var data = {
          action: settings.page_action,
          type: settings.post_type,
          template: settings.template,
          offset: offset,
          postsPerPage: postsPerPage,
          filter: filter_str,
          orderby: settings.orderby
        };
        if (action == "filter") {
          $paginateNav.show();
        }
        $.ajax({
          url: glance.ajaxUrl,
          type: "post",
          data: data,
          success: function success(result) {
            var $result = $(result);
            var numResults = $result.length;
            var maxPages = $result.first().data("max");
            var hidePaginate = numResults < postsPerPage || maxPages * postsPerPage <= offset + numResults;
            $result.find(".showOnView.slideUp").showOnView({
              transitionIn: "transition.slideUpIn"
            });
            $result.find(".showOnView.slideUpBig").showOnView({
              transitionIn: "transition.slideUpBigIn"
            });
            $result.find(".showOnView.slideLeft").showOnView({
              transitionIn: "transition.slideLeftBigIn"
            });
            $result.find(".showOnView.slideRight").showOnView({
              transitionIn: "transition.slideRightBigIn"
            });
            $result.find(".showOnView.slideIn").showOnView({
              transitionIn: "transition.fadeIn"
            });
            if (action == "paginate") {
              $result.appendTo($container);
            } else {
              $container.html($result);
            }
            if (hidePaginate) $paginateNav.hide();
            pageIsLoading = false;
            $container.removeClass("loading " + action);
            $paginateNav.removeClass("loading " + action);
          }
        });
      }
    }
    return this;
  };

  // Grid / List view toggle

  $.fn.gridListToggle = function (options) {
    var settings = $.extend({
      container: ".news-list-template",
      grid: "grid-view",
      list: "list-view"
    }, options);
    var $container = $(settings.container);
    this.on("click", "button", function () {
      var $this = $(this);
      var sel_class = $this.hasClass(settings.grid) ? settings.grid : settings.list;
      $container.removeClass(settings.grid + " " + settings.list).addClass(sel_class);
    });
    return this;
  };

  // Expanding Content

  $.fn.expandingContent = function () {
    this.on("click", function (e) {
      e.preventDefault();
      var $link = $(this);
      var $panel = $($link.attr("href")).length ? $($(this).attr("href")) : false;
      if ($panel) {
        $panel.toggleClass("open");
        $link.toggleClass("less");
      }
    });
  };
})(jQuery);